export { default } from "./Limit";



// WEBPACK FOOTER //
// ./src/components/emission/cards/limits/Limit/index.js